import React from "react";
import { Input, FormText } from "reactstrap";
import PropTypes from "prop-types";

/*
    This is a wrapper class that adds resolution validation to a normal
    file input tag. The dimensions (width and height) are passed through props or in a dimensions matrix (
      [[width1, height1], [width2, height2]....]
    )
    If a dimensions matrix is used then the width and height props will be ignored.
*/
class ImageInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  validateResolution(width, height) {
    const { width: propsWidth, height: propsHeight, dimensions } = this.props;

    /**
     * If we passed a dimensions array then we ignore the props
     */
    if (dimensions) {
      for (let i = 0; i < dimensions.length; i++) {
        const [w, h] = dimensions[i];
        if (width === w && height === h) {
          return true;
        }
      }
      return false;
    }
    /**
     * If both width and height are equal to 0 it means they haven't been specified
     * which means no validation is required
     */
    if (propsWidth !== 0 && propsHeight !== 0)
      return propsWidth === width && propsHeight === height;
    return true;
  }

  handleFileChange(event) {
    event.preventDefault();
    event.persist();
    const { validate, id } = this.props;
    const image = new Image();
    const fileChangeEvent = event;
    image.src = window.URL.createObjectURL(event.target.files[0]);
    image.onload = () => {
      const validationResult = this.validateResolution(
        image.width,
        image.height
      );
      if (validationResult) {
        this.setState({ validationResult });
        validate(id, fileChangeEvent.target.files[0]);
      } else {
        fileChangeEvent.target.value = null;
        this.setState({ validationResult });
      }
    };
  }

  render() {
    const { width, height, dimensions, validate, ...rest } = this.props;
    const { validationResult } = this.state;
    let imageInputFeedback;
    switch (validationResult) {
      case true: // Image resolution is correct, show nothing
        break;
      case false:
        if (dimensions) {
          let dimensionsFeedback = "";
          for (let i = 0; i < dimensions.length; i++) {
            dimensionsFeedback += ` ${dimensions[i][0]}x${dimensions[i][1]},`;
          }
          // Removing trailing comma
          dimensionsFeedback = dimensionsFeedback.substring(
            0,
            dimensionsFeedback.length - 1
          );
          imageInputFeedback = (
            <FormText color="danger">
              Invalid resolution. Valid resolutions: {dimensionsFeedback}
            </FormText>
          );
        } else {
          imageInputFeedback = (
            <FormText color="danger">
              Invalid resolution. required resolution is: {width}x{height}
            </FormText>
          );
        }
        break;
      default:
        if (dimensions) {
          let dimensionsFeedback = "";
          for (let i = 0; i < dimensions.length; i++) {
            dimensionsFeedback += ` ${dimensions[i][0]}x${dimensions[i][1]},`;
          }
          // Removing trailing comma
          dimensionsFeedback = dimensionsFeedback.substring(
            0,
            dimensionsFeedback.length - 1
          );
          imageInputFeedback = (
            <FormText color="muted">
              Possible resolution(s): {dimensionsFeedback}
            </FormText>
          );
        }
        // this case will be executed when validationResult is undefined, which is when the user hasn't chosen any picture yet
        else if (width !== 0 && height !== 0)
          imageInputFeedback = (
            <FormText color="muted">
              Required resolution: {width}x{height}
            </FormText>
          );
        break;
    }
    return (
      <React.Fragment>
        <Input
          {...rest}
          type="file"
          accept="image/*"
          onChange={this.handleFileChange}
        />
        {imageInputFeedback}
        {validationResult === undefined ? null : <em className="text-danger" />}
      </React.Fragment>
    );
  }
}
ImageInput.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  validate: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};
ImageInput.defaultProps = {
  width: 0,
  height: 0
};
export default ImageInput;



// WEBPACK FOOTER //
// ./src/views/components/ImageInput.jsx